<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- style="position: relative; for col-md-3" margin-left: 10px; position-fixed -->
        <div class="row ">
         
            <div class="menu-tab" >
            <div class="d-flex justify-content-start align-items-center gap-4 order-2 order-md-1 mt-4 mt-md-0">
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('general_info'); "
                    :class="{ 'menu-top': active_page === 'general_info', 'text-muted': active_page !== 'general_info' }" style="cursor: pointer;">
                    General
                </div>

                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('employement_data');"
                    :class="{ 'menu-top': active_page === 'employement_data', 'text-muted': active_page !== 'employement_data' }" style="cursor: pointer;">
                    Data
                </div>

                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('salary');"
                    :class="{ 'menu-top': active_page === 'salary', 'text-muted': active_page !== 'salary' }" style="cursor: pointer;">
                    Salary
                </div>
                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('tax_config');"
                    :class="{ 'menu-top': active_page === 'tax_config', 'text-muted': active_page !== 'tax_config' }" style="cursor: pointer;">
                    Tax 
                </div>
                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2 " @click="activePage('bpjs_config');"
                :class="{ 'menu-top': active_page === 'bpjs_config', 'text-muted': active_page !== 'bpjs_config' }" style="cursor: pointer;">
                BPJS 
                </div>

                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2 " @click="activePage('history');"
                :class="{ 'menu-top': active_page === 'history', 'text-muted': active_page !== 'history' }" style="cursor: pointer;">
                History
                </div>
                
                
                
            </div>

            </div>

            <!-- /add -->
            <form @submit.prevent="update">
            <div class="card">
                <div class="card-body" >
                
                <div class="row" :class="{ 'custom-active': active_page !== 'general_info' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'general_info'">
                    <div class="row ">
                        <div class="col-md-6 ">
                        <!-- <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Basic Info</h5>
                        </div> -->
                        <div class="">
                            <div class="d-flex align-items-center mb-2">
                                
                                <label class="col-3">ID Photo</label>
                                
                                 <!-- Upload input (hidden visually, but triggers upload) -->
                                <input
                                type="file"
                                class="form-control d-none"
                                ref="foto_ktp"
                                @change="handleUpload"
                                accept="image/*"
                                />

                                <!-- Clickable upload area -->
                                <div class="upload-box" @click="triggerUpload">
                                <template v-if="currentEmployee.foto_ktp">
                                    <img :src="currentEmployee.foto_ktp" alt="img" class="upload-preview" />
                                </template>
                                <template v-else>
                                    <!-- <span>Click to upload</span> -->
                                     <img src="@/assets/img/gallery-add.png" alt="click to upload">
                                </template>
                                </div>
                            
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                                <label for="" class="col-3" style="font-weight: 300;">Full Name <span class="text-danger">*</span></label>
                                <input type="text" v-model="currentEmployee.nama"  class="form-control" placeholder="" required>
                            
                            
                            </div>
                            
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >No.Whatsapp <span class="text-danger">*</span></label>
                              <vue-tel-input :value="currentEmployee.telepon" input-class="form-control" mode="international" :auto-format="true" @input="onPhoneChange" />

                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >Email</label>
                            <input type="text" v-model="currentEmployee.email" class="form-control" placeholder="" >
                            
                            
                            </div>
                            
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                            <!-- <div class="form-group"></div> -->
                            <label for="" class="col-3" >Birthdate <span class="text-danger">*</span></label>
                            <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.dob" class="picker" :editable="true" :clearable="false"
                                required />
                                <a class="addonset">
                                <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >Place Of Birth <span class="text-danger">*</span></label>
                            <input type="text" v-model="currentEmployee.place_dob" class="form-control" placeholder="" required>
                            
                            </div>

                            <div class="d-flex align-items-center mb-3 form-group">
                            <label  class="col-3" >Gender</label>
                            <vue-select :options="GenderList" v-model="currentEmployee.jenis_kelamin" placeholder="Pilih Jenis Kelamin" class="w-100"/>

                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label  class="col-3" >Marital Status</label>
                            <vue-select
                                :options="maritalStatusList"
                                v-model="currentEmployee.marital_status"
                                placeholder="Pilih Status Perkawinan"
                                class="w-100">
                            </vue-select>
                            <!-- <input type="text" class="form-control" v-model="currentEmployee.marital_status" placeholder=""> -->
                            
                            
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label  class="col-3" >Blood Type</label>
                            <vue-select
                                :options="bloodTypeList"
                                v-model="currentEmployee.golongan_darah"
                                placeholder="Pilih Golongan Darah"
                                class="w-100">
                            </vue-select>
                            <!-- <input type="text" class="form-control" v-model="currentEmployee.golongan_darah" placeholder=""> -->
                            
                            
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label  class="col-3" >Religion </label>
                            <vue-select :options="ReligionList" class="w-100" v-model="currentEmployee.agama" placeholder="None"  />
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-3">
                            <label  class="col-3" >Mother's Name</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nama_ibu_kandung" placeholder="">
                            
                            
                            </div>

                        </div>

                        </div>


                        <div class="col-md-6">
                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Identity & Address</h5>
                        </div>

                        <div class="">

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >NIK (KTP/Identitas)</label>
                            <input type="text" class="form-control" v-model="currentEmployee.no_ktp" placeholder="" />
                            </div>

                            <!-- <div class="d-flex align-items-center mb-3">
                            <label  class="col-3" >Postal Code</label>
                            <input type="text" v-model="currentEmployee.kode_pos" class="form-control" placeholder="" >
                            
                            
                            </div> -->

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >Citizen ID Address</label>
                            <textarea class="form-control" v-model="currentEmployee.alamat"></textarea>
                            
                            </div>

                            
                            

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >Residential ID Address</label>
                            <textarea class="form-control" v-model="currentEmployee.alamat2"></textarea>
                            
                            </div>

                            <div class="title-tab py-2 mb-3">
                            <h5 class=fw-bold>Emergency Contact</h5>
                            </div>
                            
                            <div class="d-flex align-items-center mb-2">
                              <label  class="col-3" >No. Whatsapp</label>
                              <vue-tel-input :value="currentEmployee.kontak_darurat" input-class="form-control" mode="international" :auto-format="true" @input="onPhoneEmergencyChange" />
                              
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >Name Emergency Contact</label>
                            <input type="text" v-model="currentEmployee.nama_kontak_darurat" class="form-control" placeholder="">
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                            <label  class="col-3" >Status</label>
                            <input type="text" v-model="currentEmployee.hubungan_kontak_darurat" class="form-control" placeholder="">
                            
                            </div>

                            
                            
                            
                            
                            
                            
                        </div>

                        </div>
                    </div>
                    
                    </div>
                </div>

                <div class="row" :class="{ 'custom-active': active_page !== 'employement_data' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'employement_data'">
                    <div class="row ">
                        <div class="col-md-6">
                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Basic Info</h5>
                        </div>
                        <div class="">
                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" style="font-weight: 300;">ID Employee</label>
                            <input type="text" class="form-control" v-model="currentEmployee.employee_id2" placeholder="" />
                            
                            
                            </div>
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                            <label for="" class="col-3" >Type of Attendance <span class="text-danger">*</span></label>
                            <vue-select :options="AttendanceList" v-model="currentEmployee.jenis_absensi" class="w-100" placeholder="None" required/>
                            
                            </div>

                            
                            
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                            <label for="" class="col-3" >Join Date <span class="text-danger">*</span></label>
                            <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.join_date" class="picker" :editable="true" :clearable="false"
                                required />
                                <a class="addonset">
                                <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group">
                                <label class="col-3" >Branch <span class="text-danger">*</span></label>
                                <!-- <input type="text" v-model="currentEmployee.lokasi_id" class="form-control" placeholder=""> -->
                                <vue-select :options="LocationList" :settings="{ settingOption: value, settingOption: value }"
                                    v-model="currentEmployee.lokasi_id" placeholder="None" class="w-100" required>
                                </vue-select>
                            </div>

                            <div class="d-flex align-items-center mb-3 form-group">
                                <label for="" class="col-3" >Departement</label>
                                <vue-select :options="DepartementList" :settings="{ settingOption: value, settingOption: value }"
                                    v-model="currentEmployee.departemen_id" placeholder="None" class="w-100">
                                </vue-select>

                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Job Title</label>
                              <!-- <vue-select  :options="JobTitleList" :settings="{ settingOption: value, settingOption: value }"
                                  v-model="currentEmployee.jabatan_id" class="w-100" placeholder="None">
                              </vue-select> -->
                              <model-select :options="JobTitleList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.jabatan_id" class="w-100" placeholder="None" style="z-index: 999;"></model-select>
                            
                            
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >Job Level <span class="text-danger">*</span></label>
                            <vue-select  :options="JobLevelList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.job_level" class="w-100" placeholder="None">
                            </vue-select>
                            
                            
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >Job Grade <span class="text-danger">*</span></label>
                            <vue-select  :options="GolonganList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.golongan" class="w-100" placeholder="None">
                            </vue-select>
                            
                            
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >Shift</label>
                            <vue-select :options="ShiftList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.shift_id" class="w-100" placeholder="None">
                            </vue-select>
                            
                            
                            </div>

                        </div>

                        </div>


                        <div class="col-md-6">
                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Approval Line</h5>
                        </div>

                        <div class="">

                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >Direct Suprevisor</label>
                            <vue-select :options="employeeList"   :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.atasan_langsung" class="w-100" placeholder="None">
                            </vue-select>
                            </div>

                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >Indirect Suprvisor</label>
                            <vue-select :options="employeeList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.atasan_tidak_langsung" class="w-100" placeholder="None">
                            </vue-select>
                            
                            </div>

                        
                            
                        </div>

                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Status</h5>
                        </div>

                        <div class="">

                            <div class="d-flex align-items-center mb-2 form-group">
                            <label for="" class="col-3" >Employee Status <span class="text-danger">*</span></label>
                            <vue-select :options="employeeStatusList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.employee_status" class="w-100" placeholder="None">
                            </vue-select>
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group" v-if="currentEmployee.employee_status !== 'PERMANENT'">
                            <label for="" class="col-3" >Start Date</label>
                            <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.tanggal_mulai_kontrak" class="picker" :editable="true" :clearable="false"
                                required />
                                <a class="addonset">
                                <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div>
                            
                            </div>


                            <div class="d-flex align-items-center mb-2 form-group"  v-if="currentEmployee.employee_status !== 'PERMANENT'">
                            <label for="" class="col-3" >End Date</label>
                            <div class="input-groupicon w-100" style="z-index: 99;">
                                <datepicker v-model="currentEmployee.tanggal_berakhir_kontrak" class="picker" :editable="true" :clearable="false"
                                required />
                                <a class="addonset">
                                <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group">
                            <label for="" class="col-3" >Balance Leave</label>
                            <input type="number" v-model="currentEmployee.saldo_cuti" placeholder="">
                            
                            
                            </div>

                            


                            

                        
                            
                        </div>

                        
                        <div class="title-tab py-2 mb-3" >
                          <h5 class="fw-bold">Bank Account</h5>
                        </div>

                        <div class="">

                          <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >Bank Name</label>
                            <model-select :options="bankList" :settings="{ settingOption: value, settingOption: value }"
                              v-model="currentEmployee.nama_bank" class="w-100" placeholder="None"></model-select>
                          
                            <!-- :settings="{ settingOption: value, settingOption: value }" -->
                            <!-- <input type="text" name="nama_bank" class="form-control" v-model="currentEmployee.nama_bank" /> -->
                          </div>

                          <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >Account Number</label>
                            <div class="col d-flex align-items-center gap-2 px-0">
                              <input type="text" class="form-control" :class="{ 'is-invalid': rekeningNotFound }" v-model="currentEmployee.nomor_rekening" />
                              <button  :class="(!currentEmployee.nama_bank || isChecking) ? 'btn btn-secondary' : 'btn btn-outline-primary'" type="button" @click="cekNoRek" :disabled="isChecking || !currentEmployee.nama_bank"
                              style="font-size: 12px; padding: 4px 10px;">
                                  <!--  -->
                                {{ isChecking ? ` (${checkCountdown}s)` : 'Validate' }}
                                <!-- {{ isChecking ? 'Checking...' : 'Check' }} -->
                              </button>
                              <!-- <input type="text" name="nomor_rekening" class="form-control" v-model="currentEmployee.nomor_rekening" /> -->
                            </div>
                          
                          </div>

                          <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3">Account Holder's Name</label>
                            <input type="text" name="nama_rekening" class="form-control" v-model="currentEmployee.nama_rekening" disabled/>
                            
                          </div>

                      
                          
                        </div>


                        </div>
                    </div>
                    
                    </div>
                </div>

                <div class="row" :class="{ 'custom-active': active_page !== 'salary' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'salary'">
                    <div class="row ">
                        <div class="title-tab py-2 mb-3" >
                        <h5 class="fw-bold">Salary Detail</h5>
                        </div>
                        <div class="">
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Salary <span class="text-danger">*</span></label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[0].nilai" style="width: 55%;"
                                @input="formatCurrency(currentEmployee.salary[0].nilai, 0)" required />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[0].metode" placeholder="None"
                                class="flex-fill" />
                            </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Fixed Allowance</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[1].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[1].id"
                                @input="formatCurrency(currentEmployee.salary[1].nilai, 1)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[1].metode" placeholder="None"
                                class="flex-fill" />
                            </div>

                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Attendance Allowance</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[2].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[2].id"
                                @input="formatCurrency(currentEmployee.salary[2].nilai, 2)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[2].metode" placeholder="None"
                                class="flex-fill" />
                            </div>

                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Meal Allowance</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[3].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[3].id"
                                @input="formatCurrency(currentEmployee.salary[3].nilai, 3)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[3].metode" placeholder="None"
                                class="flex-fill" />
                            </div>

                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Transport Allowance</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[4].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[4].id"
                                @input="formatCurrency(currentEmployee.salary[4].nilai, 4)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[4].metode" placeholder="None"
                                class="flex-fill" />
                            </div>

                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Non-fixed Allowance</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[5].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[5].id"
                                @input="formatCurrency(currentEmployee.salary[5].nilai, 5)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[5].metode" placeholder="None"
                                class="flex-fill" />
                            </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Other Allowances</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[6].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[6].id"
                                @input="formatCurrency(currentEmployee.salary[6].nilai, 6)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[6].metode" placeholder="None"
                                class="flex-fill" />
                            </div>

                            </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                            <label>Other Allowances 2</label>
                            <div class="d-flex gap-1">
                                <input type="text" v-model="currentEmployee.salary[7].nilai" style="width: 55%;"
                                :ref="currentEmployee.salary[7].id"
                                @input="formatCurrency(currentEmployee.salary[7].nilai, 7)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[7].metode" placeholder="None"
                                class="flex-fill" />
                            </div>
                            </div>
                        </div>


                        </div>
                        <!-- <div class="col-md-6">

                        </div> -->


                        
                    </div>
                    
                    </div>
                </div>

                <div class="row" :class="{ 'custom-active': active_page !== 'tax_config' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'tax_config'">
                    <div class="row ">
                        <div class="col-12">
                        
                        <div class="">
                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" style="font-weight: 300;">NPWP</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nomor_npwp" placeholder="">
                            
                            
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group">
                            <label for="" class="col-3" >PTKP Status</label>
                            <vue-select :options="StatusPajakList" :settings="{ settingOption: value, settingOption: value }"
                            v-model="currentEmployee.status_pajak" class="w-100" placeholder="None" />
                            </div>
                            
                            
                            
                            
                            


                        </div>

                        </div>


                        
                    </div>
                    
                    </div>
                </div>

                <div class="row" :class="{ 'custom-active': active_page !== 'bpjs_config' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'bpjs_config'">
                    <div class="row ">
                        <div class="col-md-6">
                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">BPJS Kesehatan</h5>
                        </div>

                        <div class="">
                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >No. BPJS Kesehatan</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nomor_bpjs_kesehatan" placeholder="" />
                            
                            
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                            <label for="" class="col-3" >IDR BPJS Kesehatan</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nominal_bpjs_kesehatan"  @input="formatCurrencyBpjs('nominal_bpjs_kesehatan', currentEmployee.nominal_bpjs_kesehatan)" placeholder="Rp.0,-" />
                            
                            
                            
                            
                            </div>
                        

                        </div>

                        </div>


                        <div class="col-md-6">

                        <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">BPJS Tenaga Kerja</h5>
                        </div>

                        <div class="">

                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >No. BPJS TK</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nomor_bpjs_tk" placeholder=""/>
                            </div>
                            <div class="d-flex align-items-center mb-3">
                            <label for="" class="col-3" >IDR BPJS TK</label>
                            <input type="text" class="form-control" v-model="currentEmployee.nominal_bpjs_tk" @input="formatCurrencyBpjs('nominal_bpjs_tk', currentEmployee.nominal_bpjs_tk)" placeholder="Rp.0,-"/>
                            </div>

                            

                        
                            
                        </div>

                        </div>
                    </div>
                    
                    </div>
                </div>

                <div class="row" :class="{ 'custom-active': active_page !== 'history' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'history'">
                    <div class="row ">
                        <div class="col-12">
                        

                        <div class="">
                            <div class="d-flex align-items-center mb-2">
                            
                            <textarea class="form-control" rows="5" v-model="currentEmployee.mutasi_reason" disabled>
                            </textarea>
                            
                            
                            
                            
                            </div>

                            
                        

                        </div>

                        </div>


                        
                    </div>
                    
                    </div>
                </div>



                

                </div>

            

            </div>
                <!-- /add -->

                <div class="col-lg-12" >
                
                <div class="d-flex align-items-center gap-2 ms-auto">
                    <button type="submit" class="btn btn-submit">Insert</button>
                    <router-link to="employee" class="btn btn-cancel">Cancel</router-link>
                </div>
                </div>
            
                
            </form>

        </div>
         
        
      </div>
    </div>
  </div>


</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, AlertPopup2, goPage, formatCurrency, rupiah, rupiahoutput, rupiahInput, AlertBottom, sanitizeForMySQL, appendForm, timeout} from "@/assets/js/function";
import { ModelSelect } from "vue-search-select";

import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

export default {
  components: {
    // Form,
    // Field,
    ModelSelect,
    VueTelInput,

  },
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Employee Insert",
      title1: "add new employee",
      namaCompany: "",
      config: "",
      api: "",
      foto_ktp_img: "",

      // select option
      TipeKerjaList: ["MONTH", "DAILY"],
      ShiftList: [],
      LocationList: [],
      AttendanceList: ["SCANQR", "SELFIE", "FINGERPRINT"],
      GenderList: ["MALE", "FEMALE"],
      ReligionList: ["ISLAM", "KRISTEN PROTESTAN", "KRISTEN KATOLIK", "HINDU", "BUDDHA", "KONGHUCU"],
      DepartementList: [],
      JobTitleList: [],
      employeeList: [],
      GolonganList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      StatusPajakList: [],
      JobLevelList: ["DIREKTUR", "MANAGER", "SUPERVISOR", "STAFF"],
      employeeStatusList: ["PERMANENT", "CONTRACT", "PROBATION", "INTERNSHIP"],
      maritalStatusList: ['BELUM KAWIN','KAWIN','CERAI HIDUP','CERAI MATI'],
      bloodTypeList: [ 'A', 'B', 'AB', 'O'],

      //data
      currentEmployee: {
        // id: "",
        employee_id: "",
        tipe_kerja: "",
        nama: "",
        telepon: "",
        shift_id: "0",
        lokasi_id: "0",
        jabatan_id: "0",
        departemen_id: "0",
        jenis_absensi: "",
        alamat: "",
        kontak_darurat: "",
        nomor_rekening: "",
        nama_bank: "",
        nama_rekening: "",
        foto_ktp: "",
        foto_kartukeluarga: "",
        foto_bukurekening: "",
        dob: new Date(),
        jenis_kelamin: "",
        agama: "",
        join_date: new Date(),
        // terminate_date: "",
        // terminate_reason: "",
        provinsi: "",
        kabupaten: "",
        kecamatan: "",
        kelurahan: "",
        nomor_npwp: "",
        nomor_bpjs_tk: "",
        nomor_bpjs_kesehatan: "",
        nominal_bpjs_tk: "0",
        nominal_bpjs_kesehatan: "0",
        status_pajak: "TK/0",
        golongan: "1",
        atasan_langsung: "0",
        atasan_tidak_langsung: "0",
        saldo_cuti: 0,
        salary: [
          {
            id: "1",
            jenis: "gaji",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "2",
            jenis: "tunjangan_tetap",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "3",
            jenis: "tunjangan_kehadiran",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "4",
            jenis: "tunjangan_makan",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "5",
            jenis: "tunjangan_transport",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "6",
            jenis: "tunjangan_tidak_tetap",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "7",
            jenis: "tunjangan_lain",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          },
          {
            id: "8",
            jenis: "tunjangan_lain2",
            metode: "MONTH",
            nilai: "0",
            status: "AKTIF"
          }
        ]
      },
      currentDate: new Date,


      Computers: ["Computers", "Mac"],
      None: ["None", "option1"],
      Tax: ["Choose Tax", "2%"],
      Percentage: ["Percentage", "10%", "20%"],
      Piece: ["Piece", "Kg"],
      Active: ["Active", "Open"],

      // for bank list 
      bankList: [],
      isChecking: false,
      checkCountdown: 0, // seconds left
      countdownInterval: null, // interval ID
      rekeningNotFound: false,
      hasCheckedRekening: false, 

    //   for menu-tab
      active_page: "general_info",
      isActive: true,
    };
  },

  mounted() {
    // let selectedBranch = Cookies.get("selectedBranch");
    let selectedBranch = localStorage.getItem("selectedBranch");
    if (selectedBranch !== null && selectedBranch !== undefined && selectedBranch !== '') {
      this.filter = selectedBranch !== null ? selectedBranch : 0;
    } else {
      this.filter = 0;
    }

    if (this.filter == 0) {
      alert('Cabang wajib dipilih');
      CloseLoading();
      window.location.href = '/employee'; // Redirect langsung
      return;
    }
    
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    this.namaCompany = localStorage.getItem('namaCompany');

    localStorage.setItem('actionState', 'insert')

    const bankList = JSON.parse(localStorage.getItem('bankList'));
    bankList.forEach((value, index) => {
      const element = { value: value.bank_code, text: value.name }
      this.bankList.push(element);
    });


    //load shift list
    const shift = JSON.parse(localStorage.getItem('shiftList'));
    shift.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_shift + " (" + value.jam_masuk + "-" + value.jam_pulang + ")" }
      this.ShiftList.push(element);
    });

    //load location
    const location = JSON.parse(localStorage.getItem('dataBranchList'));
    location.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_lokasi }
      this.LocationList.push(element);
    });

    //set departement
    const departement = JSON.parse(localStorage.getItem('departemenList'));
    departement.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_departemen }
      this.DepartementList.push(element);
    });

    //set jabatan
    const jabatan = JSON.parse(localStorage.getItem('jabatanList'));
    jabatan.forEach((item, index) => {
      // const element = { id: value.id, text: value.nama_jabatan }
      const element = { value: item.id, text: item.nama_jabatan }
      this.JobTitleList.push(element);
    });
    

    //set employee
    const employee = JSON.parse(localStorage.getItem('employeeList'));
    employee.forEach((value, index) => {
      const element = { id: value.id, text: value.nama }
      this.employeeList.push(element);
    });
    // Add the hardcoded "None" option at the top of the list
    this.employeeList.unshift({ id: 'null', text: "None" });
    // this.employeeList.push({ id: 'null', text: "None" });

    //set pajak 
    const pajak = JSON.parse(localStorage.getItem('statusPajakList'));
    pajak.forEach((value, index) => {
      const element = { id: value.status, text: value.status }
      this.StatusPajakList.push(element);
    });


    // load daftar bank
    // this.daftarBank();


  },
  // setup() {

  //   const schema = Yup.object().shape({
  //     name: Yup.string().required("Phone Number is required"),

  //   });

  //   return {
  //     schema,

  //   };
  // },
  methods: {
    rupiah, rupiahoutput,

    onPhoneChange(number, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.currentEmployee.telepon = phoneObject.formatted
      }

    },

    onPhoneEmergencyChange(number, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.currentEmployee.kontak_darurat = phoneObject.formatted
      }

    },

    scrollToInvalidElement() {
      const invalidElement = document.querySelector('.is-invalid');
      if (invalidElement && typeof invalidElement.scrollIntoView === 'function') {
        invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },

    // for menu-tab
    activePage(page) {
      this.active_page = page;
      localStorage.setItem("active_page", page)
    },

    // for image foto_ktp upload
    triggerUpload() {
      this.$refs.foto_ktp.click();
    },
    handleUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentEmployee.foto_ktp = e.target.result; // base64
        };
        reader.readAsDataURL(file);
      }
    },

    formatCurrency(number, index) {
      this.currentEmployee.salary[index].nilai = rupiahInput(number);
    },

    // for bpjs form input 
    formatCurrencyBpjs(name) {
      this.currentEmployee[name] = rupiahInput(this.currentEmployee[name]);
    },

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    // check bank account number to api
    async cekNoRek() {
      if (this.isChecking) return; // Prevent double click
      this.isChecking = true;

      const formData = new FormData();
      
      this.startCountdown(20); // Optional UI feature


      formData.append("token", 'd2afa5fa-c31c-4bf8-932b-c565c14ba1f1');
      formData.append("bank_code", this.currentEmployee.nama_bank);
      formData.append("account_number", this.currentEmployee.nomor_rekening);

      

      if (!this.currentEmployee.nomor_rekening || !this.currentEmployee.nama_bank) {
        
        AlertPopup2("error", "", "Please select a bank and enter account number.", false, 1500);
        this.isChecking = false;
        return;
      }

      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // return


      const api = base_url + '/v3/flip/inquiry_rekening';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      console.log('ini data cek no rek', data)
      if(data.status){

        // if (!data.ok) {
        //   // Custom handling for 404
        //   if (response.status === 404) {
        //       this.rekeningNotFound = true; // show red border
        //     throw new Error("Bank account not found");
        //   }
        //   throw new Error("HTTP error " + response.status);
        // }
        if(data.data.status == 'SUCCESS') {

          this.currentEmployee.nama_rekening = data.data.account_holder;
          this.rekeningNotFound = false;
          this.hasCheckedRekening = true;
          AlertBottom("Data found: " + data.data.account_holder);
         
        }else {
          this.currentEmployee.nama_rekening = '';
          this.rekeningNotFound = true;
          this.hasCheckedRekening = true; // <-- checked but not found

          AlertPopup2("error", "", data.message, true, 1500);

        }
        


        
      }else {
          // AlertPopup2("error", "", data.message, true, 1500);
         
          if (data.message === "Bank account not found") {
            this.rekeningNotFound = true;
            this.hasCheckedRekening = true; // <-- checked but not found
            AlertPopup2("error", "", data.message, true, 1500);

          

          } else {
            AlertPopup2("error", "", data.message, true, 1500);
          }
      }

      
    },


    startCountdown(seconds) {
      this.checkCountdown = seconds;

      this.countdownInterval = setInterval(() => {
        this.checkCountdown--;

        if (this.checkCountdown <= 0) {
          clearInterval(this.countdownInterval);
          this.isChecking = false;
        }
      }, 1000);
    },

    

    formatDate(dateInput) {
      const dateObj = new Date(dateInput);
      if (isNaN(dateObj.getTime())) return null; // Invalid date check

      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async update() {
      // let formData = new FormData();
      // formData.append("company_type", localStorage.getItem("company_type") || "");
      const formData = new FormData();
      appendForm(formData)

      

      Object.entries(this.currentEmployee).forEach(([key, value]) => {
        formData.append(key, sanitizeForMySQL(value));
      });
      //deleteemplpyee id because its necessary
      formData.delete("employee_id");

      const teleponClean = this.currentEmployee.telepon.slice(1).replace(/\s+/g, "")
      formData.set("telepon", teleponClean);

      const kontakEmergencyClean = this.currentEmployee.kontak_darurat.slice(1).replace(/\s+/g, "")
      formData.set("kontak_darurat", kontakEmergencyClean);

      //set to indonesia again to save
      formData.delete("tipe_kerja");
      if (this.currentEmployee.tipe_kerja == 'DAILY') {
        formData.append("tipe_kerja", "HARIAN");
      } else {
        formData.append("tipe_kerja", "BULANAN");
      }

      //set to jenis_kelamin to indonesia to save
      formData.delete("jenis_kelamin");
      if (this.currentEmployee.jenis_kelamin == 'MALE') {
        formData.append("jenis_kelamin", "PRIA");
      } else {
        formData.append("jenis_kelamin", "WANITA");
      }
      formData.delete("salary");

      //set salary back to indonesia to save
      formData.append("jenis", "gaji#tunjangan_tetap#tunjangan_kehadiran#tunjangan_makan#tunjangan_transport#tunjangan_tidak_tetap#tunjangan_lain#tunjangan_lain2");

      // set salary
      let metode = "";
      let nilai = "";
      this.currentEmployee.salary.forEach((value, index) => {
        if (index != 7) {
          if (this.currentEmployee.salary[index].metode == "MONTH") {
            metode = metode + "BULANAN#"
          } else {
            metode = metode + "HARIAN#"
          }
          nilai = nilai + rupiahoutput(this.currentEmployee.salary[index].nilai) + "#"
        } else {
          if (this.currentEmployee.salary[index].metode == "MONTH") {
            metode = metode + "BULANAN"
          } else {
            metode = metode + "HARIAN"
          }
          nilai = nilai + rupiahoutput(this.currentEmployee.salary[index].nilai)
        }
      });
      formData.append("metode", metode);
      formData.append("nilai", nilai);

      //set dob
      formData.delete("dob");
      const dobDate = this.formatDate(this.currentEmployee.dob);
      if (dobDate) {
        formData.append("dob", dobDate);
      }

      //set join date
      formData.delete("join_date");
      const joinDate = this.formatDate(this.currentEmployee.join_date);
      if (joinDate) {
        formData.append("join_date", joinDate);
      }

      //set start date & end date contract
      formData.delete("tanggal_mulai_kontrak");
      const tanggalKontrak = this.formatDate(this.currentEmployee.tanggal_mulai_kontrak);
      if (tanggalKontrak) {
        formData.append("tanggal_mulai_kontrak", tanggalKontrak);
      }

      formData.delete("tanggal_berakhir_kontrak");
      const tanggalEndKontrak = this.formatDate(this.currentEmployee.tanggal_berakhir_kontrak);
      if (tanggalEndKontrak) {
        formData.append("tanggal_berakhir_kontrak", tanggalEndKontrak);
      }

      //set image
      formData.delete("foto_ktp");
      formData.delete("foto_bukurekening");
      formData.delete("foto_kartukeluarga");

      if (this.$refs.foto_ktp.value != "") {
        formData.append("foto_ktp", this.$refs.foto_ktp.files[0]);
      }
    
      if (!this.currentEmployee.job_level || this.currentEmployee.job_level === "") {
        AlertPopup('error', '', 'Job Level wajib dipilih!', 1500, false);
        return
      } else if (!this.currentEmployee.employee_status || this.currentEmployee.employee_status === "") {
        AlertPopup('error', '', 'Employee Status wajib dipilih!', 1500, false);
        return
      } else if (this.currentEmployee.nomor_rekening && this.currentEmployee.nomor_rekening.trim() !== "") {
        if (!this.currentEmployee.nama_rekening || this.currentEmployee.nama_rekening.trim() === "") {
          AlertPopup2('error', '', 'Silahkan cek Rekening terlebih dahulu!', true, 1500);
          return;
        }
        // else if (this.rekeningNotFound) {
        //   AlertPopup("error", "", "Nomor rekening harus valid dan terdaftar!", 1500, false);
        //   return;
        // }else if (!this.hasCheckedRekening) {
        //   AlertPopup("error", "", "Silakan cek nomor rekening terlebih dahulu!", 1500, false);
        //   return;
        // }
      }

      // for status_karyawan
      formData.delete("status_karyawan");
      formData.append("status_karyawan", this.currentEmployee.employee_status);

      // Safely handle nominal_bpjs_tk
        formData.delete("nominal_bpjs_tk");
        if (this.currentEmployee.nominal_bpjs_tk != null && this.currentEmployee.nominal_bpjs_tk !== '') {
        formData.append("nominal_bpjs_tk", rupiahoutput(this.currentEmployee.nominal_bpjs_tk));
        } else {
        formData.append("nominal_bpjs_tk", '');
        }

        // Safely handle nominal_bpjs_kesehatan
        formData.delete("nominal_bpjs_kesehatan");
        if (this.currentEmployee.nominal_bpjs_kesehatan != null && this.currentEmployee.nominal_bpjs_kesehatan !== '') {
        formData.append("nominal_bpjs_kesehatan", rupiahoutput(this.currentEmployee.nominal_bpjs_kesehatan));
        } else {
        formData.append("nominal_bpjs_kesehatan", '');
        }

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // CloseLoading()
      // return true

      const api = base_url + 'v3/employees/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      if (data.status) {
          AlertBottom(data.message);
          goPage("employee");

          
      } else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      



    },
  },

};
</script>

<style scoped>
  /* for select phone number country code */
  ::v-deep .vti__dropdown-list {
    z-index: 999 !important; /* higher than Bootstrap modal default */
  }
  
  ::v-deep .vti__dropdown-list.below {
    z-index: 999 !important; /* higher than Bootstrap modal default */
  }

.upload-box {
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  width: 200px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  margin-left: 1rem;
}

.upload-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}


/* for menu tab style */

.menu-top {
    background-color: #09B67D33; /* Adjust opacity and color as needed */
    /* border-bottom: 4px solid #073C69; Primary color (Bootstrap default) */
    color: #09B67D; /* Dark text color (Bootstrap default) */
    font-weight: 500;
    border-radius: 5px 5px 0 0;
}

.responsive-detail {
    max-height: 100vh; /* Or any height you want */
    overflow-y: auto;

    /* Hide scrollbar for WebKit browsers */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
}

.responsive-detail::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}


/* for class invalid no rek */
.is-invalid {
  border-color: red;
  color: red;
}

</style>
